// src/sim/round/constants.ts — P3 round-lifecycle tunable constants (GAME-01, GAME-02, GAME-08).
//
// Invariants:
//   - No side effects; module-level numeric constants only.
//   - Every value is tick-count-based (no milliseconds; no pixels).
//   - Mark P7-tunable values with `// TODO(P7 POL-06): retune from playtest`.
//
// Source: .planning/phases/03-core-sim-primitives/03-CONTEXT.md D-09.

/** 5-minute round cap at 30 Hz = 9000 ticks (GAME-02). TODO(P7 POL-06): retune from playtest. */
export const P3_ROUND_DURATION_TICKS = 9000;

/** Hider head-start duration at 30 Hz = 240 ticks ≈ 8 s (GAME-01, retuned from Phase 11 device UAT 2026-07-04). */
export const P3_HEADSTART_DURATION_TICKS = 240;

/** Diegetic team-switch duration at 30 Hz = 210 ticks ≈ 7 s (D-09 + Pitfall 26). TODO(P7 POL-06): retune from playtest. */
export const P3_TEAMSWITCH_DURATION_TICKS = 210;
